module.exports = __webpack_public_path__ + "images/emoji/bust_in_silhouette.5afe5b1b69de812fe081.png";